import { ClientNavbar } from "./client-navbar";

interface ClientLayoutProps {
  children: React.ReactNode;
}

export function ClientLayout({ children }: ClientLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <ClientNavbar />
      <main className="mx-auto max-w-6xl p-6">{children}</main>
    </div>
  );
}
